/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

const FeedSourceServices = {
    getFeedSources: () => fetch(`/api/feedSources/`, options),
    getFeedSource: (id) => fetch(`/api/feedSources/${id}`, options),
    postFeedSource: (role) =>
        fetch(`/api/feedSources/`, Object.assign({}, options, {
            method: 'POST',
            body: JSON.stringify(role)
        })),
    deleteFeedSource: (id) =>
        fetch(`/api/feedSources/${id}`, Object.assign({}, options, {
            method: 'DELETE'
        }))
};

export default {
    FeedSourceServices
};